import * as React from 'react'
import win from '../Assets/wingo.png'
import trxwin from '../Assets/trxwin.png'
import k3 from '../Assets/k3.png'
import racing from '../Assets/racing.png'
import fiveD from '../Assets/5D.png'
import { Link } from 'react-router-dom'
import avatar from '../Assets/avatar/avatar.png'
import stage from '../Assets/places/stage.png'
import img1 from '../Assets/avatar/1.png'
import img2 from '../Assets/avatar/2.png'
import img3 from '../Assets/avatar/3.png'
import img4 from '../Assets/avatar/4.png'
import img5 from '../Assets/avatar/5.png'
import crown1 from '../Assets/places/crown1.png'
import crown2 from '../Assets/places/crown2.png'
import crown3 from '../Assets/places/crown3.png'
import place1 from '../Assets/places/place1.png'
import place2 from '../Assets/places/place2.png'
import place3 from '../Assets/places/place3.png'
function LotteryGames(){

    const colors = [
        "green",
        "red", // Lighter green
        "blue",
        "purple",
        "#66cc66",
      ];
      const games = [
        {
            name:'Win Go',
            img:win,
            slug:'wingo'
        },{
            name:'Trx Win Go',
            img:trxwin,
            slug:'trxwin'
        },{
            name:'Racing',
            img:racing,
            slug:'racing'
        },{
            name:'K3',
            img:k3,
            slug:'k3'
        },{
            name:'5D',
            img:fiveD,
            slug:'5D'
        },
      ]
      const winners = [
          {
            id:'meme****360',
            img:img3,
            game:win,
            amount:9314    
          },{
            id:'meme****581',
            img:img1,
            game:trxwin,
            amount:5414    
          },{
            id:'meme****421',
            img:img2,
            game:k3,
            amount:300    
          },{
            id:'meme****221',
            img:img4,
            game:win,
            amount:4007    
          },{
            id:'meme****274',
            img:img5,
            game:fiveD,
            amount:8492
          },
      ]

      const topwins = [
        {
          id:'meme****360',
          img:img4,
          amount:'387,00.00'    
        },{
          id:'meme****581',
          img:img5,
          amount:'125,990.00'
        },
    ]

      return(
        <div className='mt-2 w-full '>
            
            <p className='font-bold text-black  py-4 mt-4'>Lottery </p>
            <div className='grid grid-cols-1 gap-6 mt-2 w-full'>
            {games.map((game, index) =>
        //     // Cycle through colors using modulo
        // const primaryColor = colors[index % colors.length];
        // return 
            (
            <Link to={`lottery/${game.slug}`} className='w-full lottery_slots'>
                <div className='w-full flex flex-col justify-between p-3 rounded-lg '>

                
                <div className='flex justify-between p-2 rounded-lg '>

                <div className='flex flex-col justify-between'>
                    <p className='font-bold text-white text-2xl'>{game.name}</p>
                    <div className='flex flex-col p-1'>
                        <p className='font-semibold text-white text-sm'>Guess the number</p>
                    </div>
                </div>
                    <img className='-mt-10' width={110} src={game.img} alt=''/>
                </div>
                   {game.name === 'Win Go' || game.name === 'Trx Win Go' ? <div className='flex   p-2 px-4 font-semibold text-white text-sm'>
                        
                        <p>Green</p>/
                        <p>Red</p>/
                        <p>Purple</p>
                    </div>
                    :
                    <div className='flex   p-2 px-4 font-bold text-white text-sm'>
                        <p>Big</p>/
                        <p>Small</p>/
                        <p>Odd</p>/
                        <p>Even</p>
                    </div>
                    }
                    </div>
                    <div className='mem flex items-center bg-white rounded-t-lg'>
                        <img style={{ width:'40px', borderRadius:'50%' }} className='p-2' src={avatar} alt={''}/>
                        <div className='flex justify-between w-full p-1 '>
                            <p className='text-black text-sm'>Mem****234</p>
                            <p className='text-black text-sm'>Winning Amount: $400</p>
                        </div>
                    </div>
            </Link>))}
            <div className='winning_info'>
                <p style={{ borderLeft:'solid rgb(255, 81, 0) 3px' }} className='font-semibold text-sm px-2 my-2 '>Winning information</p>
                <div className='grid grid-rows-5 gap-2 p-2'>
                {winners.map((winner) =>(
                    <div key={winner.id} className='shadow-md flex justify-between items-center space-x-1 bg-white p-2 rounded-lg'>
                        <img style={{ width:'30px', height:'30px' }} className='rounded-full' src={winner.img} alt={winner.id}/>
                        <p className='font-semibold text-sm'>{winner.id}</p>
                        <div className='bg-orange-400 rounded-lg md:px-1'>
                            <img style={{ width:'50px', height:'40px' }} src={winner.game} alt={winner.id}/>
                        </div>
                        <div className='flex flex-col justify-center items-center space-y-1'>
                            <p className='font-semibold text-sm'>${winner.amount}.00</p>
                            <p className='text-sm text-gray-400'>Winning amount</p>
                        </div>
                    </div>    
                    ))}
                </div>
            </div>
            <div className='stage '>
                <p style={{ borderLeft:'solid orange 3px' }} className='font-semibold px-2 my-4 '>Today's earnings rank</p>
            </div>
            <div className='w-full flex flex-col justify-center items-center'>

                <div className='relative mt-8 w-[360px] '>
                    <img src={stage} alt='' />
                    <img className='absolute top-0 left-[40%] w-[80px] z-[2]' src={place1} alt='' />
                    <img className='absolute top-5 left-4 w-[80px] z-[2]' src={place2} alt='' />
                    <img className='absolute top-5 right-4 w-[80px] z-[2]' src={place3} alt='' />
                    <img className='absolute w-[50px] -top-[70px] left-[140px] z-[2]' src={crown1} alt='' />
                    <img className='absolute w-[50px] left-4 -top-[50px] z-[2]' src={crown2} alt='' />
                    <img className='absolute w-[50px] right-[50px] -top-[50px] z-[2]' src={crown3} alt='' />
                    <img className='absolute w-[50px] rounded-full -top-[40px] left-[160px]' src={img1} alt='' />
                    <img className='absolute w-[50px] rounded-full left-8 -top-[20px]' src={img2} alt='' />
                    <img className='absolute w-[50px] rounded-full right-8 -top-[20px]' src={img3} alt='' />

                    <div className='absolute top-[3rem] left-4 space-y-2'>
                        <p className='text-white text-sm'>mem****225</p>
                        <p className='btn-bg rounded-full text-white text-[0.8rem] text-center'>525,000.00</p>
                    </div>
                    <div className='absolute top-[3rem] right-4 space-y-2'>
                        <p className='text-white text-sm'>mem****226</p>
                        <p className='btn-bg rounded-full text-white text-[0.8rem] text-center'>440,518.00</p>
                    </div>
                    <div className='absolute top-[1.5rem] left-[40%] space-y-2'>
                        <p className='text-white text-sm'>mem****162</p>
                        <p className='btn-bg rounded-full text-white text-[0.8rem] text-center'>937,938.00</p>
                    </div>
                    <div className='absolute w-full top-[120px] grid grid-rows-2 gap-2'>
                    {topwins.map((winner, index) =>(
                    <div key={winner.id} className='flex justify-between items-center space-x-1 bg-white p-2 py-3 rounded-[5px]'>
                        <div className='flex space-x-2 justify-center items-center'>
                        <p className='text-gray-400 px-2 font-semibold'>{index + 4}</p>
                        <img style={{ width:'30px', height:'30px' }} className='rounded-full' src={winner.img} alt={winner.id}/>
                        <p className='font-semibold px-2 text-sm'>{winner.id}</p>
                        </div>
                        <div className='flex flex-col justify-center items-center space-y-1'>
                            <p className='btn-bg rounded-full text-white px-2 text-center text-sm'>${winner.amount}</p>
                        </div>
                    </div>    
                    ))}
                </div>
                </div>
            </div>
            </div>
        </div>
    )
}


export default LotteryGames